// src/api/collection/collectionApi.ts
import { axiosInstance } from "src/api/axiosInstance";

import type {
  ApiResponse,
  ServerPageContent, // ✅ 추가
  CollectionNode,
  CollectionHierarchyQuery,
  CollectionUpsertPayload,
} from "src/types/collection/collectionTypes";

const BASE = "/v1/admin/baseinfo/collection";
export const getCollectionHierarchyApi = async (
  params: CollectionHierarchyQuery
): Promise<ApiResponse<ServerPageContent<CollectionNode>>> => {
  const res = await axiosInstance.get<ApiResponse<ServerPageContent<CollectionNode>>>(
    `${BASE}/tree`,
    {
      params: {
        ...params,
        collectionName: params.collectionName || undefined,
        parentCollectionId:
          typeof params.parentCollectionId === "number" ? params.parentCollectionId : undefined,
        depth: typeof params.depth === "number" ? params.depth : undefined,
        isActive: typeof params.isActive === "boolean" ? params.isActive : undefined,
        isFeatured: typeof params.isFeatured === "boolean" ? params.isFeatured : undefined,
        order: params.order || "displayOrder,asc",
      },
    }
  );
  return res.data;
};
export const getCollectionApi = async (id: number): Promise<ApiResponse<CollectionNode>> => {
  const res = await axiosInstance.get<ApiResponse<CollectionNode>>(`${BASE}/${id}`);
  return res.data;
};

const normalizeCollectionPayload = (payload: CollectionUpsertPayload): CollectionUpsertPayload => {
  return {
    ...payload,
    parentCollectionId:
      payload.parentCollectionId === 0 ? (null as any) : payload.parentCollectionId,
  };
};

const buildCollectionPayload = (
  payload: CollectionUpsertPayload,
  options: { omitCode?: boolean } = {}
) => {
  const normalized = normalizeCollectionPayload(payload);
  if (!options.omitCode) return normalized;
  const { collectionCode, ...rest } = normalized;
  return rest;
};
export const createCollectionApi = async (
  payload: CollectionUpsertPayload
): Promise<ApiResponse<null>> => {
  const body = buildCollectionPayload(payload);
  const res = await axiosInstance.post<ApiResponse<null>>(`${BASE}`, body);
  return res.data;
};

export const updateCollectionApi = async (
  id: number,
  payload: CollectionUpsertPayload
): Promise<ApiResponse<null>> => {
  const body = buildCollectionPayload(payload, { omitCode: true });
  const res = await axiosInstance.put<ApiResponse<null>>(`${BASE}/${id}`, body);
  return res.data;
};

export const deleteCollectionApi = async (id: number): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.delete<ApiResponse<null>>(`${BASE}/${id}`);
  return res.data;
};
